import { ref, computed, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import cookieControl from '../../foundation/js/cookieControl'
export default {
    name: "PriceToggle",
    setup() {
        const store = useStore()
        const toggled = computed(() => store.state.ecom.show_msrp)

        const showPriceToggle = computed(() => store.state.main.show_price_toggle)

        const toggle = () => {
            const newStatus = !toggled.value
            store.commit('ecom/set_show_msrp', newStatus)
            cookieControl.setItem('show_msrp', newStatus)
        }

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        onBeforeMount(() => {
            if (showPriceToggle.value) {
                const cookieMsrpStatus = !!(cookieControl.getItem('show_msrp') === 'true')
                store.commit('ecom/set_show_msrp', cookieMsrpStatus)
            } else {
                cookieControl.removeItem('show_msrp')
            }
        })

        return {
            toggled,
            toggle,
            getLabel,
            showPriceToggle
        }
    }
}